import React, { useCallback } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import { AtsMessageTemplatesSelectorDocument } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { messageTemplateVisibilityLabel } from 'modules/ats/lib/utils/messageTemplates'

interface Props {
  onMessageTemplateChanged: (messageTemplateContent: string, templateId: string) => void
  messageTemplateId?: string
  open?: boolean
  onOpenChange?: (isOpen: boolean) => void
}

export const MessageTemplatesSelector = ({
  onMessageTemplateChanged,
  messageTemplateId,
  open,
  onOpenChange,
}: Props) => {
  const [selectedMessageTemplateId, setSelectedMessageTemplateId] = React.useState<
    string | undefined
  >(messageTemplateId)

  const { data, loading } = useQuery(AtsMessageTemplatesSelectorDocument)
  const messageTemplates = data?.ats.messageTemplatesConnection.nodes || []

  const onSelectTemplate = (id: string) => {
    const messageTemplateContent = messageTemplates.find((el) => el.id === +id)?.body || ''
    onMessageTemplateChanged(messageTemplateContent, id)
    setSelectedMessageTemplateId(id)
  }

  const orderedMessageTemplates = orderBy(
    messageTemplates,
    [
      (messageTemplate) => messageTemplate.visibility === 'company',
      (messageTemplate) => messageTemplate.name,
    ],
    ['desc', 'asc']
  )

  const options = orderedMessageTemplates.map((messageTemplate) => ({
    value: messageTemplate.id.toString(),
    label: `${messageTemplateVisibilityLabel(messageTemplate.visibility)} - ${
      messageTemplate.name
    }`,
  }))

  const searchMessageTemplate = useCallback(
    (option: { label: string; value: string }, search: string): boolean => {
      const term = search?.trim().toLowerCase() || ''
      if (term.length === 0) return true
      return option.label?.toLowerCase().includes(term)
    },
    []
  )

  return (
    <Box width="full">
      <F0Select
        options={options}
        onChange={(value: string) => onSelectTemplate(value)}
        value={selectedMessageTemplateId}
        disabled={loading}
        open={open}
        onOpenChange={onOpenChange}
        showSearchBox
        searchBoxPlaceholder={i18n.t('common.search')}
        searchFn={searchMessageTemplate}
        placeholder={i18n.t('ats.manage_message_templates.custom_message_option')}
      />
    </Box>
  )
}
